import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import statusCalculate from 'altrac-application-status'
import { displayFormula } from 'altrac-conversions'
import CheckMark from '../Graphics/SelectionCheckIcon'
import CircleExclamation from '../Graphics/CircleExclamation'
import { SpeedometerOff } from '../Graphics/Speedometer'

// HOC
import withAppStore from '../../../util/withAppStore'

import styles from '../../../../css/devicePage.module.css'
import colors from '../../../../css/colors.module.css'

const DeviceCompact = function DeviceCompact ({
  device,
  selected,
  selectedState,
  tileInfo,
  enableRpm,
  tempConv,
}) {
  let returnValue = ''
  if (device) {
    const status = statusCalculate(device)
    const {
      id,
      address,
      customer_id: customerID,
      reading0 = {},
      reading1 = {},
      physical: {
        deviceNumber: name = '',
        deviceType,
      } = {},
      interface_versioned: interfaceV,
    } = device

    let path = `/${customerID}/devices/${id}`
    switch (deviceType) {
      case 'moistureSensor':
        path = `/${customerID}/moistureSensor/${id}`
        break
      case 'pump':
        if (interfaceV && interfaceV.data && typeof interfaceV.data.other === 'object' && interfaceV.data.other.page === 'flow') {
          path = `/${customerID}/flow/${id}`
        } else {
          path = `/${customerID}/pump/${id}`
        }
        break
      case 'valve':
        if (interfaceV && interfaceV.data && typeof interfaceV.data.other === 'object' && interfaceV.data.other.page === 'flow') {
          path = `/${customerID}/flow/${id}`
        } else {
          path = `/${customerID}/valve/${id}`
        }
        break
      case 'flow':
        path = `/${customerID}/flow/${id}`
        break
      default:
        path = `/${customerID}/devices/${id}`
        break
    }

    let tile = null

    if (
      interfaceV &&
      interfaceV.data &&
      interfaceV.data.tile &&
      typeof interfaceV.data.tile === 'object'
    ) {
      tile = interfaceV.data.tile
    } else if (
      device.interface &&
      device.interface.tile &&
      typeof device.interface.tile === 'object'
    ) {
      tile = device.interface.tile
    }

    let enableRpmTemp = enableRpm
    if (
      interfaceV &&
      interfaceV.data &&
      interfaceV.data.primaryPage.settingTypes
    ) {
      enableRpmTemp = interfaceV.data.primaryPage.settingTypes.includes('rpmTarget')
    }

    if (tileInfo === 'default') {
      if (
        tile !== null &&
        (
          tile.type === 'generic' ||
          !tile.type
        )
      ) {
        let displayValue = 'N/A'
        let unitAbbreviation = ''
        displayValue = displayFormula(
          tile.formula,
          tile.multiplier,
          tile.precision,
          { tempConv },
          tile.valueKey,
          reading0 || {},
          reading1 || {},
          device.physical || {}
        )
        unitAbbreviation = tile.unitAbbreviation
        returnValue = (
          <TileCompact
            path={path}
            value={displayValue}
            unitAbbreviation={unitAbbreviation}
            unit={tile.unit}
            label={name || address}
            code={status.code}
            statusId={status.id}
            statusShortMessage={status.shortMessage}
            warningIndicator={status.warningIndicator}
            manualIndicator={status.manualIndicator}
            stateIndicator={status.stateIndicator}
            selected={selected}
            selectedState={selectedState}
          />
        )
      } else if (
        tile !== null &&
        (
          tile.type === 'Pump2'
        )
      ) {
        returnValue = (
          <TileCompactPump2
            path={path}
            device={device}
            status={status}
            selected={selected}
            selectedState={selectedState}
          />
        )
      } else if (
        tile !== null &&
        (
          tile.type === 'Pump2Single'
        )
      ) {
        returnValue = (
          <TileCompactPump2Single
            path={path}
            device={device}
            status={status}
            selected={selected}
            selectedState={selectedState}
          />
        )
      } else {
        returnValue = (
          <TileCompact
            path={path}
            value='?'
            unitAbbreviation=''
            unit='Unknown device'
            label={name || address}
            code={status.code}
            statusId={status.id}
            statusShortMessage={status.shortMessage}
            warningIndicator={status.warningIndicator}
            manualIndicator={status.manualIndicator}
            stateIndicator={status.stateIndicator}
          />
        )
      }
    } else if (tileInfo === 'rpm') {
      const applicationSettingsNew = device.application_settings_new
      const applicationSettings = device.application_settings
      const unitAbbreviation = ''

      let intendedSetting
      let settingStatusNew
      let speed

      if (
        applicationSettingsNew &&
        applicationSettingsNew.settings &&
        applicationSettingsNew.status === 'new' &&
        applicationSettingsNew.settings.speed
      ) {
        speed = applicationSettingsNew.settings.speed
        if (speed >= 1000) {
          intendedSetting = `${(speed / 1000).toFixed(1).replace(/\.0$/, '')}k`
        } else {
          intendedSetting = speed
        }
        settingStatusNew = 1
      } else if (
        applicationSettings &&
        applicationSettings.settings &&
        applicationSettings.settings.speed
      ) {
        speed = applicationSettings.settings.speed
        if (speed >= 1000) {
          intendedSetting = `${(speed / 1000).toFixed(1).replace(/\.0$/, '')}k`
        } else {
          intendedSetting = speed
        }
      }

      if (!intendedSetting) {
        intendedSetting = 'NOT SET'
      }

      returnValue = (
        <TileCompact
          value={intendedSetting}
          unitAbbreviation={unitAbbreviation}
          unit={tile.unit}
          label={name || address}
          code={status.code}
          statusId={status.id}
          statusShortMessage={status.shortMessage}
          warningIndicator={status.warningIndicator}
          manualIndicator={status.manualIndicator}
          stateIndicator={status.stateIndicator}
          selected={selected}
          selectedState={selectedState}
          settingStatusNew={settingStatusNew}
          isEnabled={enableRpmTemp}
          tileInfo={tileInfo}
        />
      )
    }
  }

  return (
    <div>
      {returnValue}
    </div>
  )
}

DeviceCompact.propTypes = {
  device: PropTypes.object,
  selected: PropTypes.func,
  selectedState: PropTypes.bool,
  tileInfo: PropTypes.string,
  enableRpm: PropTypes.bool,
  tempConv: PropTypes.string.isRequired,
}

export default withAppStore(DeviceCompact)

const TileCompact = function TileCompact ({
  path,
  value,
  unitAbbreviation,
  label,
  code,
  statusId,
  warningIndicator,
  stateIndicator,
  manualIndicator,
  selected,
  selectedState,
  settingStatusNew,
  isEnabled,
  tileInfo,
}) {
  let values = null
  let color = colors.normal
  switch (code) {
    case 'deviceProblem':
      color = colors.deviceProblem
      break
    case 'danger':
      color = colors.danger
      break
    case 'warning':
      color = colors.warning
      break
    case 'success':
      color = colors.success
      break
    case 'disconnected':
      color = colors.disconnected
      break
    case 'info':
      color = colors.info
      break
    default:
      color = colors.normal
  }
  switch (statusId) {
    case 'notConnected':
      values = (
        <div className={styles.valueInfo}>
          <span name='notConnected' className='fa fa-wifi fa-3x' />
        </div>
      )
      break

    case 'valveOnAndShouldBeOn':
      values = (
        <div className={styles.valueInfo}>
          <h2 className={styles.tileHeader}>AUTO</h2>
        </div>
      )
      break
    case 'valvePressureOffSolenoidOnScheduledRecent':
      values = (
        <div className={styles.valueInfo}>
          <h2 className={styles.tileHeader}>ON</h2>
        </div>
      )
      break
    case 'valvePressureOffSolenoidOnScheduled':
      values = (
        <div className={styles.valueInfo}>
          <h2 className={styles.tileHeader}>AUTO</h2>
        </div>
      )
      break
    case 'valvePressureOnSolenoidOffNotScheduled':
      values = (
        <div className={styles.valueInfo}>
          <h2>MAN</h2>
        </div>
      )
      break
    case 'valveOffAndShouldBeOff':
    case 'valveOnAndShouldBeOffScheduled':
      values = (
        <div className={styles.valueInfo}>
          <h2>OFF</h2>
        </div>
      )
      break
    case 'valvePressureOnSolenoidErrorScheduled':
      values = (
        <div className={styles.valueInfo}>
          <h2 className={styles.tileHeader}>AUTO</h2>
        </div>
      )
      break
    case 'valvePressureOnSolenoidOnNotScheduled':
      values = (
        <div className={`${styles.valueInfo} ${styles.successExclamation}`}>
          <span name='deviceExclamationIssue'>
            <CircleExclamation color='#D00000' />
          </span>
        </div>
      )
      break
    case 'windMachineControllerAutoBadTempProbe':
      values = (
        <div className={styles.valueInfo}>
          <span name='deviceExclamationIssue' className='fa fa-exclamation-circle fa-3x' />
        </div>
      )
      break
    case 'temperatureBadReading':
      values = (
        <div className={styles.valueInfo}>
          <span name='temperatureBadReading' className='fa fa-thermometer-empty fa-3x' />
        </div>
      )
      break
    case 'pumpControllerAutoPressureBadReading':
    case 'pressureBadReading':
      values = (
        <div className={styles.valueInfo}>
          <SpeedometerOff color='inherit' />
        </div>
      )
      break
    case 'pumpShouldBeOnState':
    case 'pumpControllerPowerOff':
      if (value === 'ERH' || value === 'OFF') {
        values = (
          <div className={styles.valueInfo}>
            <SpeedometerOff color='inherit' />
          </div>
        )
      } else {
        values = (
          <div className={styles.valueInfo}>
            <h2 className={styles.tileValue}>
              {value}
              {unitAbbreviation}
            </h2>
          </div>
        )
      }
      break
    case 'windMachineExternalBatteryLow':
    case 'windMachineBelowStartNotRunning':
    case 'windMachineBelowStartNotRunningConfirmed':
      break
    default:
      if (
        code === 'deviceProblem' ||
        code === 'warning'
      ) {

      } else if (code === 'danger') {
        values = (
          <div className={styles.valueInfo}>
            <span name='deviceExclamationIssue' className='fa fa-exclamation-circle fa-3x' />
          </div>
        )
      }
  }
  let textColor
  if (settingStatusNew) { color = '#000'; textColor = '#D00000' }
  if (selectedState) { color = colors.normal }
  if (!isEnabled && tileInfo === 'rpm') { color = colors.selected }
  if (!values) {
    if (value === null) {
      if (unitAbbreviation === '°') {
        values = (
          <div className={styles.valueInfo}>
            <span name='temperatureBadReading' className='fa fa-thermometer-empty fa-3x' />
          </div>
        )
      } else {
        values = (
          <div className={styles.valueInfo}>
            <h2 className={styles.tileValue}>
              -
            </h2>
          </div>
        )
      }
    } else if (value === 'NOT SET') {
      values = (
        <div className={`${styles.valueInfo} ${styles.emptySetting}`} style={{ color: textColor }}>
          <span className={styles.valueInfoString}>
            {value}
          </span>
        </div>
      )
    } else if (
      typeof value === 'string' &&
      (value.includes('\n') || value.length > 3)
    ) {
      values = (
        <div className={styles.valueInfo} style={{ color: textColor }}>
          <span className={styles.valueInfoString}>
            {value}
            {unitAbbreviation}
          </span>
        </div>
      )
    } else {
      values = (
        <div className={styles.valueInfo} style={{ color: textColor }}>
          <h2 className={styles.tileValue}>
            {value}
            {unitAbbreviation}
          </h2>
        </div>
      )
    }
  }

  let warningIndicatorReturn
  if (warningIndicator) {
    warningIndicatorReturn = (<div className={`${styles.circle} ${styles.warningIndicator}`} name='indicator' />)
  }
  let manualIndicatorReturn
  if (manualIndicator) {
    manualIndicatorReturn = (<div className={`${styles.circle} ${styles.manualIndicator}`} name='indicator' />)
  }
  let stateIndicatorReturn
  if (stateIndicator) {
    stateIndicatorReturn = (<div className={`${styles.circle} ${styles.stateIndicator}`} name='indicator' />)
  }

  return (
    <Link to={path} onClick={selected}>
      <button className={`${styles.tileButton} ${color}`} type='button'>
        {selectedState ? <div className={`${styles.svgWrapper}`}><CheckMark /></div> : ''}
        <div className={styles.tile}>
          {values}
          <div>
            <h6 className={styles.label} style={{ color: textColor }}>{label}</h6>
          </div>
        </div>
        <div className={styles.indicatorWrapper}>
          {stateIndicatorReturn}
          {warningIndicatorReturn}
          {manualIndicatorReturn}
        </div>
      </button>
    </Link>
  )
}
TileCompact.propTypes = {
  path: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  unitAbbreviation: PropTypes.string,
  unit: PropTypes.string,
  id: PropTypes.string,
  code: PropTypes.string,
  label: PropTypes.string,
  warningIndicator: PropTypes.bool,
  stateIndicator: PropTypes.bool,
  manualIndicator: PropTypes.bool,
  selected: PropTypes.func,
  selectedState: PropTypes.bool,
  settingStatusNew: PropTypes.number,
  isEnabled: PropTypes.bool,
  tileInfo: PropTypes.string,
}

const stater = (state, auto, hoaDetect, hoaDetector) => {
  let indicator = (<div className={`${styles.circle} ${styles.manual2Indicator}`} name='indicator' />)
  if (hoaDetect && !hoaDetector) {
    indicator = (<div className={`${styles.circle} ${styles.manualIndicator}`} name='indicator' />)
  } else if (auto) {
    indicator = (<div className={`${styles.circle} ${styles.stateIndicator}`} name='indicator' />)
  }

  const out = {
    color: colors.normal,
    colorBorder: null,
    text: '',
    indicator,
  }

  switch (Number(state)) {
    case 0:
    case 1:
      out.color = colors.normal
      out.text = 'OFF'
      out.colorBorder = styles.whiteWithBorder
      break
    case 2:
      out.color = colors.normal
      out.text = 'OFF'
      break
    case 3:
    case 4:
    case 5:
    case 6:
      out.color = colors.info
      out.text = 'OFF'
      break
    case 7:
    case 8:
      out.color = colors.danger
      out.text = <CircleExclamation color='#D00000' size='auto' />
      break
    case 9:
      out.color = colors.info
      out.text = 'ON'
      break
    case 10:
    case 11:
    case 12:
      out.color = colors.success
      out.text = auto ? 'AUTO' : 'MAN'
      break
    case 13:
    case 14:
    case 15:
      out.color = colors.info
      out.text = 'ON'
      break
    case 16:
      out.color = colors.normal
      out.text = 'OFF'
      break
    default:
      break
  }

  return out
}

const TileCompactPump2 = function TileCompactPump2 ({
  path,
  device,
  status,
  selected,
  selectedState,
}) {
  const {
    reading0: {
      R1S,
      R2S,
      XA,
      XB,
      DI1,
      DI2,
      DI3,
    },
    physical: {
      deviceNumber: label = 'P2',
      ioDigUse1,
      ioDigUse2,
      ioDigUse3,
    } = {},
  } = device
  const textColor = ''

  if (status.id && status.id === 'notConnected') {
    return (
      <Link to={path} onClick={selected}>
        <button className={`${styles.tileButton} ${colors.deviceProblem}`} type='button'>
          {selectedState ? <div className={`${styles.svgWrapper}`}><CheckMark /></div> : ''}
          <div className={styles.tile}>
            <div className={styles.valueInfo}>
              <span name='notConnected' className='fa fa-wifi fa-3x' />
            </div>
            <div>
              <h6 className={styles.label} style={{ color: textColor, height: '28px' }}>{label}</h6>
            </div>
          </div>
        </button>
      </Link>
    )
  }

  let R1Detect = false
  let R1Detector = false
  if (ioDigUse1 === 'autoDetectPump1') {
    R1Detect = true
    R1Detector = !!DI1
  } else if (ioDigUse2 === 'autoDetectPump1') {
    R1Detect = true
    R1Detector = !!DI2
  } else if (ioDigUse3 === 'autoDetectPump1') {
    R1Detect = true
    R1Detector = !!DI3
  }

  const R1I = stater(R1S, XA, R1Detect, R1Detector)

  let R2Detect = false
  let R2Detector = false
  if (ioDigUse1 === 'autoDetectPump2') {
    R2Detect = true
    R2Detector = !!DI1
  } else if (ioDigUse2 === 'autoDetectPump2') {
    R2Detect = true
    R2Detector = !!DI2
  } else if (ioDigUse3 === 'autoDetectPump2') {
    R2Detect = true
    R2Detector = !!DI3
  }
  const R2I = stater(R2S, XB, R2Detect, R2Detector)

  return (
    <Link to={path} onClick={selected}>
      <button className={`${styles.tileButton} ${colors.normal}`} type='button'>
        {selectedState ? <div className={`${styles.svgWrapper}`}><CheckMark /></div> : ''}
        <div className={styles.tile}>
          <div
            className={`${styles.valueInfo} ${styles.doubleTile}`}
            style={{
              color: textColor,
            }}
          >
            <div
              className={`${R1I.color} pumpOneTile`}
              style={{
                position: 'absolute',
                left: 0,
                right: '50%',
                top: 0,
                bottom: '40px',
                display: 'flex',
                flexDirection: 'column',
                borderTopLeftRadius: '10px',
                borderRight: '1px solid rgb(211,211,211)',
                borderBottom: '2px solid rgb(211,211,211)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '6px',
                  right: '6px',
                }}
                className={`${R1I.colorBorder}`}
              >
                {R1I.indicator}
              </div>
              <span className={styles.dualTileText}>
                {R1I.text}
              </span>
            </div>
            <div
              className={`${R2I.color} pumpTwoTile`}
              style={{
                position: 'absolute',
                right: 0,
                left: '50%',
                top: 0,
                bottom: '40px',
                display: 'flex',
                flexDirection: 'column',
                borderTopRightRadius: '10px',
                borderLeft: '1px solid rgb(211,211,211)',
                borderBottom: '2px solid rgb(211,211,211)',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '6px',
                  right: '6px',
                }}
                className={`${R2I.colorBorder}`}
              >
                {R2I.indicator}
              </div>
              <span className={styles.dualTileText}>
                {R2I.text}
              </span>
            </div>
          </div>
          <div>
            <h6 className={styles.label} style={{ color: textColor, height: '28px' }}>{label}</h6>
          </div>
        </div>
      </button>
    </Link>
  )
}
TileCompactPump2.propTypes = {
  path: PropTypes.string,
  device: PropTypes.object,
  status: PropTypes.object,
  selected: PropTypes.func,
  selectedState: PropTypes.bool,
}

const TileCompactPump2Single = function TileCompactPump2Single ({
  path,
  device,
  status,
  selected,
  selectedState,
}) {
  const {
    reading0: {
      R1S,
      XA,
      DI1,
      DI2,
      DI3,
    },
    physical: {
      deviceNumber: label = 'P2',
      ioDigUse1,
      ioDigUse2,
      ioDigUse3,
    } = {},
  } = device
  const textColor = ''

  if (status.id && status.id === 'notConnected') {
    return (
      <Link to={path} onClick={selected}>
        <button className={`${styles.tileButton} ${colors.deviceProblem}`} type='button'>
          {selectedState ? <div className={`${styles.svgWrapper}`}><CheckMark /></div> : ''}
          <div className={styles.tile}>
            <div className={styles.valueInfo}>
              <span name='notConnected' className='fa fa-wifi fa-3x' />
            </div>
            <div>
              <h6 className={styles.label} style={{ color: textColor, height: '28px' }}>{label}</h6>
            </div>
          </div>
        </button>
      </Link>
    )
  }

  let R1Detect = false
  let R1Detector = false
  if (ioDigUse1 === 'autoDetectPump1') {
    R1Detect = true
    R1Detector = DI1
  } else if (ioDigUse2 === 'autoDetectPump1') {
    R1Detect = true
    R1Detector = DI2
  } else if (ioDigUse3 === 'autoDetectPump1') {
    R1Detect = true
    R1Detector = DI3
  }

  const R1I = stater(R1S, XA, R1Detect, R1Detector)

  return (
    <Link to={path} onClick={selected}>
      <button className={`${styles.tileButton} ${R1I.color}`} type='button'>
        {selectedState ? <div className={`${styles.svgWrapper}`}><CheckMark /></div> : ''}
        <div className={styles.tile}>
          <div
            className={`${styles.valueInfo} `}
            style={{
              color: textColor,
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '6px',
                right: '6px',
              }}
              className={`${R1I.colorBorder}`}
            >
              {R1I.indicator}
            </div>
            <div>
              <h2 className={styles.tileHeader}>
                {R1I.text}
              </h2>
            </div>
          </div>
          <div>
            <h6 className={styles.label} style={{ color: textColor }}>{label}</h6>
          </div>
        </div>
      </button>
    </Link>
  )
}
TileCompactPump2Single.propTypes = {
  path: PropTypes.string,
  device: PropTypes.object,
  status: PropTypes.object,
  selected: PropTypes.func,
  selectedState: PropTypes.bool,
}
